export default "__VITE_ASSET__ZxgnDzoA__"